import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { numberWithDots } from '../../../helpers';
import { decreaseStepByOne, setHealthValue } from '../../../actions';
import seriousDiseasesImage from '../../../assets/health/icon-serious-diseases.png';
import oncologicalImage from '../../../assets/health/icon-oncological.png';

const SelectedAnswersWrapper = styled.div`
  .SelectedAnswers {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 10px;
    margin: 0;
    margin-bottom: 30px;
    grid-auto-flow: column;
    background-color: #f3f3f3;
    padding: 12px;
    border-radius: 3px;

    &-answerButton {
      padding: 10px 24px 10px 16px;
      font-size: 16px;
      margin: 5px;
      border-radius: 5px;
      white-space: nowrap;
      position: relative;
      cursor: pointer;
      color: var(--white-color);
      background-color: var(--blue-color);
    }

    &-text {
      display: flex;
      align-items: center;

      img {
        width: 24px;
        margin-right: 10px;
      }
    }

    &-answerCross {
      position: absolute;
      font-size: 14px;
      top: 0;
      right: 10px;
    }
  }
`;

const SelectedAnswers = ({
  disease,
  capital,
  removeSelectedAnswer,
  selectedStep
}) => {
  return (
    <SelectedAnswersWrapper>
      <div className="SelectedAnswers">
        {disease !== null ? (
          <div
            className="SelectedAnswers-answerButton"
            onClick={() => removeSelectedAnswer('disease', selectedStep)}
          >
            <span className="SelectedAnswers-text">
              {disease === 0 ? (
                <>
                  <img src={seriousDiseasesImage} alt="" />
                  Enfermedades graves
                </>
              ) : (
                <>
                  <img src={oncologicalImage} alt="" />
                  Oncológico
                </>
              )}
            </span>
            <span className="SelectedAnswers-answerCross">x</span>
          </div>
        ) : null}

        {capital ? (
          <div
            className="SelectedAnswers-answerButton"
            onClick={() => removeSelectedAnswer('capital', selectedStep)}
          >
            <span className="SelectedAnswers-text">
              U$S {numberWithDots(capital)}
            </span>
            <span className="SelectedAnswers-answerCross">x</span>
          </div>
        ) : null}
      </div>
    </SelectedAnswersWrapper>
  );
};

const mapStateToProps = state => {
  return {
    capital: state.health.capital,
    disease: state.health.disease,
    selectedStep: state.steps.selectedStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    removeSelectedAnswer: (cleanValue, currentStep) => {
      if (cleanValue === 'disease') {
        dispatch(setHealthValue('disease', null));

        if (currentStep.pos === 3) {
          dispatch(decreaseStepByOne());
          dispatch(decreaseStepByOne());
        }

        if (currentStep.pos === 4) {
          dispatch(decreaseStepByOne());
          dispatch(decreaseStepByOne());
          dispatch(decreaseStepByOne());
        }
      }

      if (cleanValue === 'capital') {
        dispatch(setHealthValue('capital', 0));

        if (currentStep.pos === 4) {
          dispatch(decreaseStepByOne());
        }
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedAnswers);
